module.exports = __webpack_public_path__ + "img/hp.39cbca38.jpg";